import * as React from 'react';
import './Tooltip.scss';

abstract class TooltipElementInterface extends React.Component<{}, {items: Tooltip[]}> {
  abstract addItem(tooltip: Tooltip);
  abstract removeItem(tooltip: Tooltip);
}

  /* tslint:disable-next-line */
type TooltipProps = {
  text?: string,
  showOnlyOnOverflow?: boolean
};

export default class Tooltip extends React.Component<TooltipProps, {position: ClientRect | null}> {

  static Element = class extends TooltipElementInterface {
    addItem(modal: Tooltip) {
      this.setState((state) => {
        state.items.push(modal);
        return state;
      });
    }
    removeItem(modal: Tooltip) {
      this.setState((state) => {
        state.items.splice(state.items.indexOf(modal), 1);
      });
    }
    constructor(props: {}) {
      super(props);
      this.state = {
        items: []
      };
      Tooltip.instance = this;
    }
    render() {
      const { items } = this.state;
      return (
        <>
          {items.map((item) => {
            const { text } = item.props;
            const { position } = item.state;
            return text && position ? ( 
              <div 
                className="tooltip" 
                key={item.id} 
                style={{
                  right: document.body.clientWidth - position.left, 
                  top: position.top + position.height / 2}}
              >
                {text}
              </div>
            ) : null;
          })}
        </>
      );
    }
  };
  private static count: number = 0;
  private static instance: TooltipElementInterface;
  /* tslint:disable-next-line */
  component: React.ReactElement<any>;
  refCache: HTMLElement | null = null;
  id: number = ++Tooltip.count;
  constructor(props: TooltipProps) {
    super(props);
    this.state = {
      position: null
    };
    Tooltip.instance.addItem(this);
  }
  // Recursively determines the min width of an element and it's children
  minElementWidth = (el: HTMLElement): number => {
    let currentWidth = el.offsetWidth || Infinity;
    return Math.min(currentWidth, ...Array.from(el.children).map(child => this.minElementWidth(child as HTMLElement)));
  }
  /** 
   * Determines if the child component is overflowing into the parent component
   * @param el: The child element to be checked.
   * @return The position, or null if the tooltip should not be rendered
   */
  offset = (el: HTMLElement): ClientRect | null => {
    const { showOnlyOnOverflow = false } = this.props;
    if (showOnlyOnOverflow) {
      let minOffsetWidth = this.minElementWidth(el);
      let paddingSize = 0;
      if (el.parentElement) {
        paddingSize += parseFloat(window.getComputedStyle(el.parentElement).paddingLeft || '');
        paddingSize += parseFloat(window.getComputedStyle(el.parentElement).paddingRight || '');
      }
      if (el.parentElement && minOffsetWidth < (el.parentElement.clientWidth - paddingSize)) return null;
    }
    
    const rect = el.getBoundingClientRect()!!,
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      bottom: rect.bottom + scrollTop,
      left: rect.left + scrollLeft,
      right: rect.right + scrollLeft,
      height: rect.height,
      width: rect.height
    };
}
  startHover = () => {
    this.setState({position: this.offset(this.refCache!!)}, () => Tooltip.instance.forceUpdate());
  }
  stopHover = () => {
    this.setState({position: null}, () => Tooltip.instance.forceUpdate());
  }
  /* tslint:disable-next-line */
  handleRef = (el: any, ref: HTMLElement) => {
    if (ref !== this.refCache) {
      if (this.refCache !== null) {
        this.refCache.removeEventListener('mouseenter', this.startHover);
        this.refCache.removeEventListener('mouseleave', this.stopHover);
      }
      this.refCache = ref;
      if (this.refCache != null) {
        this.refCache.addEventListener('mouseenter', this.startHover);
        this.refCache.addEventListener('mouseleave', this.stopHover);
      }
    }
    if (el.ref) el.ref(ref);
  }
  render() {
    const el = React.Children.only(this.props.children);
    // @ts-ignore
    return React.cloneElement(el, { ref: this.handleRef.bind(this, el) });
  }
  componentWillUnmount() {
    Tooltip.instance.removeItem(this);
  }
} 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Tooltip/index.tsx